module.exports = __webpack_public_path__ + "img/redpack.834e0d9a.svg";